import { CarrierType } from '@/model/CarrierType';
import { getConfig, getRule } from '@/api/modules/config';
import { parseUrlParams } from '@/utils/';
const state = {
    selfInfo: {
        uid: '',
        token: '',
        'dev-brand': '',
        'dev-manufacturer': '',
        'dev-model': '',
        'dev-language': '',
        'dev-region': '',
        'dev-timezone': '',
        'dev-app-version': '',
        'dev-channel': '',
        'dev-package': '',
        'dev-id': '',
        'dev-pid': ''
    },
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo') || '{}') : {},
    HTisLogin: false,
    darkbg: undefined,
    darkColor: '',
    cookieId: '',
    loginStatus: !!localStorage.getItem('userInfo'),
    codeValidate: false,
    backIconWhite: true,
    configData: {},
    processConfig: {},
    isAllowedPrivacy: false
};
const mutations = {
    SET_COOKIEID(state, cookieId) {
        state.cookieId = cookieId;
    },
    SET_IS_ALLOWED_PRIVACY(state, isAllowedPrivacy) {
        state.isAllowedPrivacy = isAllowedPrivacy;
    },
    SET_BACK_ICON_WHITE(state, backIconWhite) {
        state.backIconWhite = backIconWhite;
    },
    SET_SELFINFO_UID: (state, uid) => {
        state.selfInfo.uid = uid;
        window.localStorage.setItem('themeOpid', uid);
    },
    SET_SELFINFO: (state, selfInfo) => {
        state.selfInfo = selfInfo;
    },
    SET_DARKBG: (state, darkbg) => {
        state.darkbg = darkbg;
    },
    SET_DARKCOLOR: (state, darkColor) => {
        state.darkColor = darkColor;
    },
    SET_USERINFO: (state, res) => {
        state.userInfo = res;
    },
    // 是否真正登录
    SET_LOGIN_STATUS: (state, data) => {
        state.loginStatus = !!data;
    },
    // 验证码是否验证通过
    SET_CODE_VALIDATE: (state, data) => {
        state.codeValidate = !!data;
    },
    SET_TOKEN: (state, TOKEN) => {
        state.userInfo.TOKEN = TOKEN;
    },
    SET_HUAN_TAI_ISLOGIN(state, isLogin) {
        state.HTisLogin = isLogin;
    },
    SET_CONFIG_DATA(state, data) {
        state.configData = Object.assign({}, state.configData, data);
    },
    SET_PROCESS_CONFIG_DATA(state, data) {
        // 创建默认配置
        const defaultConfig = {
            1: {
                page: false,
                dialog: false,
                rules: '',
                protocolStatus: false,
                dialogTitle: '',
                dialogContent: '',
                dialogBtn: ''
            },
            2: {
                page: false,
                dialog: false,
                rules: '',
                protocolStatus: false,
                dialogTitle: '',
                dialogContent: '',
                dialogBtn: ''
            },
            3: {
                page: false,
                dialog: false,
                rules: '',
                protocolStatus: false,
                dialogTitle: '',
                dialogContent: '',
                dialogBtn: ''
            }
        };
        // 将 data 合并到默认配置中，并赋值给 state.processConfig
        state.processConfig = Object.assign({}, defaultConfig, data);
    }
};
const actions = {
    getConfigPage({ commit }) {
        return new Promise((resolve, reject) => {
            getConfig()
                .then((res) => {
                commit('SET_CONFIG_DATA', res.data);
                debugger;
                const curerntPageParams = parseUrlParams(location.href);
                // 主题默认展示
                if (res.data.theme_btn_phone === '1') {
                    if (curerntPageParams.pcid && (curerntPageParams.pcid.startsWith('ot'))) {
                        if (window.ThemeClient && window.ThemeClient.isLogin()) {
                            commit('SET_HUAN_TAI_ISLOGIN', true);
                        }
                        else {
                            commit('SET_HUAN_TAI_ISLOGIN', false);
                        }
                    }
                }
                resolve(res.data);
            })
                .catch((err) => {
                reject(err);
            });
        });
    },
    getProcessConfigPage({ commit }) {
        return new Promise((resolve, reject) => {
            getRule()
                .then((res) => {
                console.log('获取配置');
                // 初始化数据结构，包含默认值'
                const data = {
                    [CarrierType.TELECOM]: {
                        page: false,
                        dialog: false,
                        rules: '',
                        protocolStatus: false,
                        dialogTitle: '',
                        dialogContent: '',
                        dialogBtn: ''
                    },
                    [CarrierType.CUCC]: {
                        page: false,
                        dialog: false,
                        rules: '',
                        protocolStatus: false,
                        dialogTitle: '',
                        dialogContent: '',
                        dialogBtn: ''
                    },
                    [CarrierType.MIGU]: {
                        page: false,
                        dialog: false,
                        rules: '',
                        protocolStatus: false,
                        dialogTitle: '',
                        dialogContent: '',
                        dialogBtn: ''
                    }
                };
                // 创建运营商类型映射
                const carrierTypeMap = {
                    [Number(CarrierType.TELECOM)]: CarrierType.TELECOM,
                    [Number(CarrierType.CUCC)]: CarrierType.CUCC,
                    [Number(CarrierType.MIGU)]: CarrierType.MIGU
                };
                // 处理响应数据
                for (const i of res.data) {
                    const carrierKey = carrierTypeMap[i.sourceType];
                    // 如果是支持的运营商类型且尚未设置自定义数据
                    if (carrierKey && !data[carrierKey].rules) {
                        data[carrierKey] = {
                            page: i.pageStatus === 1,
                            dialog: i.popupStatus === 1,
                            rules: i.pageContent,
                            protocolStatus: typeof i.protocolStatus === 'number' ? !!i.protocolStatus : false,
                            dialogTitle: i.dialogTitle,
                            dialogContent: i.dialogContent,
                            dialogBtn: i.dialogBtn
                        };
                    }
                }
                commit('SET_PROCESS_CONFIG_DATA', data);
                resolve(res.data);
            })
                .catch((err) => {
                reject(err);
            });
        });
    }
};
export default {
    namespaced: true,
    state,
    mutations,
    actions
};
